import { BaseController } from './BaseController';

export default class ToggleController extends BaseController {
  id = 'ToggleController';

  init() {
    this.root = this.getRoot();

    this.target = document.getElementById(this.getData(this.root, 'target'));
    this.root.addEventListener('click', this.handleToggle);
  }

  handleToggle = (e) => {
    this.target.classList.toggle('d-none');
  };
}